module.exports = __webpack_public_path__ + "static/marta-sorli-c7758e8d89572b365fac5ecd4c8d562a.jpg";